export const UPLOADED_FILES_BASE_URL = "/api/v1/uploaded-files";
